import { render, staticRenderFns } from "./UpdatePassordModal.vue?vue&type=template&id=63a57f6c&scoped=true"
import script from "./UpdatePassordModal.vue?vue&type=script&lang=js"
export * from "./UpdatePassordModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassordModal.vue?vue&type=style&index=0&id=63a57f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a57f6c",
  null
  
)

export default component.exports